import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

/**
 * Component to handle domain-based routing for monadmm.xyz
 * When users visit monadmm.xyz, automatically route them to Monad pages
 */
const MonadDomainRedirect: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Check if we're on the Monad domain
    const isMonadDomain = 
      window.location.hostname === 'monadmm.xyz' || 
      window.location.hostname === 'www.monadmm.xyz';

    if (!isMonadDomain) {
      return; // Not on Monad domain, no redirect needed
    }

    const path = location.pathname;

    // Handle root path - redirect to /monad
    if (path === '/') {
      navigate('/monad', { replace: true });
      return;
    }

    // Handle /token/:tokenAddress - redirect to /monad/token/:tokenAddress
    const tokenMatch = path.match(/^\/token\/(0x[a-fA-F0-9]{40})$/);
    if (tokenMatch) {
      const tokenAddress = tokenMatch[1];
      navigate(`/monad/token/${tokenAddress}`, { replace: true });
      return;
    }

    // For any other path on monadmm.xyz, redirect to /monad
    // (unless it's already a /monad path)
    if (!path.startsWith('/monad')) {
      navigate('/monad', { replace: true });
      return;
    }
  }, [location.pathname, navigate]);

  return <>{children}</>;
};

export default MonadDomainRedirect;

